import { Tenant } from '@framework/tenant/vo/types/Tenant';
import appendNestedCallbackUrl from '@framework/url/helpers/appendNestedCallbackUrl';
import usersUrl from '@users/url';
import logoutTargets from './logoutTargets';

export default function getLogoutTarget({
  tenant,
  callbackUrl,
  isAutoLogout = false,
  errorCode,
  errorData,
  showToast,
}: {
  tenant: Tenant,
  callbackUrl: string,
  isAutoLogout?: boolean,
  errorCode?: number,
  errorData?: any,
  showToast?: boolean,
}): string {
  let target: string;

  for (let logoutTarget of logoutTargets) {
    if (logoutTarget.pattern.test(callbackUrl)) {
      target = logoutTarget.getTarget(isAutoLogout);
      break;
    }
  }

// @ts-ignore TODO: FIN-32798 strictNullChecks
  if (!target) {
    target = usersUrl.getLoginUrl();
  }

  const targetWithCallback = callbackUrl ? appendNestedCallbackUrl(target, callbackUrl) : target;
  const targetParsed = new URL(targetWithCallback);
  const callbackUrlParsed = new URL(callbackUrl);

  if (tenant || callbackUrlParsed.searchParams.get('tenant')) {
    // @ts-ignore
    targetParsed.searchParams.set('tenant', tenant || callbackUrlParsed.searchParams.get('tenant'));
  }
  if (errorCode) {
    targetParsed.searchParams.set('error_code', errorCode.toString());
  }
  if (errorData) {
    targetParsed.searchParams.set('error_data', encodeURIComponent(JSON.stringify(errorData)));
  }
  if (showToast) {
    // @ts-ignore
    targetParsed.searchParams.set('show_toast', 1);
  }

  return targetParsed.href;
}

(global as any).getLogoutTarget = getLogoutTarget;
